import React, { useEffect, useState } from "react";
import "./Delivered_order.css";
import Breadcrumb_comp from "../../common-components/breadcrumb-comp/Breadcrumb_comp";
import Order_id_holder from "../order_details/order_id_holder/Order_id_holder";
import Order_details_table from "../order_details/order_details_table/Order_details_table";
import Receiver_info_holder from "../order_details/receiver_info_holder/Receiver_info_holder";
import Payment_Summary from "../order_details/payment_Summary/Payment_Summary";
import { decodeId } from "../../../utils/common";
import { useDispatch, useSelector } from "react-redux";
import { getOrder } from "../../../features/order/orderSlice";
import { useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Green_btn from "../../common-components/common_btn/green_btn/Green_btn";
import Green_Outline_Btn from "../../common-components/common_btn/green_outline_btn/Green_Outline_Btn";
import Rating from "react-rating";
import { faStar as farStar } from "@fortawesome/free-regular-svg-icons";
import { faStar as fasStar } from "@fortawesome/free-solid-svg-icons";
import { Form } from "react-bootstrap";
import Delete_Modal from "../../common-components/common_modal/delete_modal/Delete_Modal";
import { Controller, useForm } from "react-hook-form";
import { contactusForm } from "../../../features/contact_us/contactusSlice";
import { postRating } from "../../../features/rating/ratingSlice";
import Success_Modal from "../../common-components/common_modal/success_modal/Success_Modal";
import Product_Rating from "../../product_details/product_Rating/Product_Rating";

function Delivered_order() {
  const [modalShow, setModalShow] = React.useState(false);
  const breadcrumbs = [
    { label: "Home", link: "/", isActive: false },
    { label: "My Orders", link: "/account", state: { tab: "My Orders" }, isActive: false },
    { label: "Delivered Order", link: "", isActive: true },
  ];

  const dispatch = useDispatch();
  const { id } = useParams(); // encoded ID from URL
  const [orderId, setOrderId] = useState(null); // decoded ID

  const [showReviewModal, setShowReviewModal] = useState(false);

  useEffect(() => {
    if (id) {
      const decoded = decodeId(id);
      setOrderId(decoded);
    }
  }, [id]);

  const order = useSelector((state) => state.order.order);
  useEffect(() => {
    if (orderId) {
      // Ensure ID is valid before dispatching
      dispatch(getOrder({ id: orderId, order_status_id: "" }));
    }
  }, [dispatch, orderId]);

  const {
    register,
    handleSubmit,
    control,
    getValues,
    formState: { errors },
  } = useForm({
    defaultValues: {
      rating: "",
      review: "",
    },
  });

  const [showSuccessModal, setShowSucsessModal] = useState(false);
  const [productId, setProductId] = useState("");
  const [showReviewRating, setShowReviewRating] = useState(false);
  const onSubmit = async (d) => {
    const data = {
      ratings: d.ratings,
      review: d.review,
      product_id: productId,
      order_id: order?.id,
    };

    const res = await dispatch(postRating(data));

    if (res.meta?.requestStatus === "fulfilled") {
      setShowSucsessModal(true);
      dispatch(getOrder({ id: orderId, order_status_id: "" }));
    } else if (res.meta?.requestStatus === "rejected") {
    }
  };

  return (
    <>
      <section className="Delivered_order Order_details theme_bg_colour">
        <Breadcrumb_comp breadcrumbs={breadcrumbs} />

        <div className="container-fluid">
          <div className="row">
            <div className=" col-lg-8 col-md-7">
              <Order_id_holder order={order} headingText="Order ID #859865" />

              <Order_details_table
                order={order}
                setProductId={setProductId}
                productId={productId}
                type="Deliver"
                setShowReviewRating={setShowReviewRating}
                showReviewRating={showReviewRating}
              />
              {/* Review section */}

              <div>
                <Product_Rating product={order} />
              </div>
            </div>
            <div className="col-lg-4 col-md-5">
              <Receiver_info_holder order={order} />

              <Payment_Summary order={order} />
            </div>
          </div>
        </div>
      </section>

      <Delete_Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        successText="Rating and Reviews Submited Sucessfuly"
      />

      <Success_Modal
        show={showSuccessModal}
        onHide={() => {
          setShowSucsessModal(false);
        }}
        successText="Password Reseted Successfully!"
      />
    </>
  );
}

export default Delivered_order;
